import { TENANTS_URL } from '../constants'; // Define the base URL for tenants API
import { apiSlice } from './apiSlice';

export const tenantsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all tenants with filtering and pagination
    getTenants: builder.query({
      query: ({ keyword = '', pageNumber = 1 }) => ({
        url: TENANTS_URL,
        params: { keyword, pageNumber }, // Enable filtering and pagination
      }),
      keepUnusedDataFor: 5, // Cache unused data for 5 seconds
      providesTags: ['Tenants'], // Tag used for cache invalidation
    }),

    // Fetch a single tenant by ID
    getTenantDetails: builder.query({
      query: (tenantId) => ({
        url: `${TENANTS_URL}/${tenantId}`,
      }),
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),

    // Create a new tenant
    createTenant: builder.mutation({
      query: (data) => ({
        url: TENANTS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Tenants'], // Refresh tenant list cache
    }),

    // Update an existing tenant by ID
    updateTenant: builder.mutation({
      query: (data) => ({
        url: `${TENANTS_URL}/${data.tenantId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Tenants'], // Refresh tenant list after update
    }),

    // Delete a tenant by ID
    deleteTenant: builder.mutation({
      query: (tenantId) => ({
        url: `${TENANTS_URL}/${tenantId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tenants'], // Refresh tenant list cache
    }),

    // Fetch top tenants (based on specific criteria such as sales)
    getTopTenants: builder.query({
      query: () => `${TENANTS_URL}/top`,
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),
  }),
});

export const {
  useGetTenantsQuery, // Hook to fetch all tenants
  useGetTenantDetailsQuery, // Hook to fetch details of a specific tenant
  useCreateTenantMutation, // Hook to create a tenant
  useUpdateTenantMutation, // Hook to update a tenant
  useDeleteTenantMutation, // Hook to delete a tenant
  useGetTopTenantsQuery, // Hook to fetch top tenants
} = tenantsApiSlice;